/**
 * kdsSound — new-ticket alert for the Kitchen Display Screen.
 *
 * Plays the provided alert clip at the app's maximum gain (1.0). That's the
 * ceiling a web/Electron app is allowed to control — there is no API that
 * lets an app raise the OS/device's own output volume, by design. Never
 * attenuating below 1.0 is what "matches device sound level" means in
 * practice; the actual final loudness is still capped by the OS volume.
 */

import newItemAlertUrl from '@assets/sounds/new_item_alert.wav';

let audio: HTMLAudioElement | null = null;

const getAudio = (): HTMLAudioElement => {
  if (!audio) {
    audio = new Audio(newItemAlertUrl);
    audio.volume = 1.0;
  }
  return audio;
};

export function playKdsNewTicketSound(): void {
  try {
    const el = getAudio();
    el.currentTime = 0;
    el.play().catch((err) => {
      console.warn('[KDS] Failed to play new-ticket sound:', err);
    });
  } catch (err) {
    console.warn('[KDS] Failed to play new-ticket sound:', err);
  }
}
